import { getIsWearEnabled } from './getIsWearEnabled';
import { getWearRedirectUrl } from './getWearRedirectUrl';
import { isWearOnlyUser } from './isWearOnlyUser';

/**
 * @description Returns the URL a Wear-only user should be sent to after login,
 * or undefined when they should go through the normal post-login routing.
 *
 * All three must hold:
 * - the user only has Wear scopes (isWearOnlyUser)
 * - the org has a Wear native app with a usable URL (getWearRedirectUrl)
 * - IS_WEAR_ENABLED is on for the org (getIsWearEnabled)
 *
 * The scope and URL checks run first and need no network call, so the flag is
 * only fetched for users who would actually be redirected.
 */
export const getWearOnlyUserRedirectUrl = async ({
  tokenScopeListItem,
  heliumEndpoint,
  token,
}: {
  tokenScopeListItem?: Utils.ArrayElement<
    Api.Response['describeAccessToken']['tokenScopeList']
  >;
  heliumEndpoint: string;
  token?: string | null;
}): Promise<string | undefined> => {
  if (!isWearOnlyUser(tokenScopeListItem)) return;

  const wearUrl = getWearRedirectUrl(tokenScopeListItem?.org);
  if (!wearUrl) return;

  const isWearEnabled = await getIsWearEnabled({
    heliumEndpoint,
    token,
    orgId: tokenScopeListItem?.org?.id,
  });

  return isWearEnabled ? wearUrl : undefined;
};
